export const parseRepository = (repo: string) => {
  const i = repo.lastIndexOf("/");
  if (i === -1) {
    return ["", repo];
  }
  return [repo.slice(0, i), repo.slice(i + 1)];
};
